import React, { useEffect, useState } from "react";
import { Button, MenuItem, Paper, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { ProductCategoryForHomePage } from "src/components/api/register_product_category/registerProductCategory";
import { ToastError, ToastSuccess } from "src/components/uiElements/toast";
import { LOGOUT } from "src/components/helper/constants";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

type RequestProps = {};

export default function CustomCategoryButton() {
  const [open, setOpen] = useState(false);
  const [selectCategoryList, setSelectCategoryList] = useState([]);
 const navigate = useNavigate();
  const defaultValues = {};

  const validationSchema = Yup.object().shape({
    //SuperStarName: Yup.string().required("Super star name is required"),
  });

  const formContext = useForm<RequestProps>({
    defaultValues,
    resolver: yupResolver(validationSchema) as any,
  });
  const { reset, setValue } = formContext;

  const resetForm = () => {
    reset({});
  };

  useEffect(() => {
    ProductCategoryList();
  }, []);

  const ProductCategoryList = async () => {
    setSelectCategoryList([]);
    const response = await ProductCategoryForHomePage();
    if (!response?.isAuthorized) LOGOUT();
    if (!response?.status) {
      let failResult = JSON.parse(response?.data!);
      ToastError(failResult.Message);
      return;
    }
    var data = JSON.parse(response?.data!);
    setSelectCategoryList(data);
  };

  return (
    <Box
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      sx={{
        position: "relative",
        zIndex: 10,
        marginTop: "6px",
        display: {
          xs: "none",
          sm: "none",
          md: "none",
          lg: "block",
          xl: "block",
        },
      }}
    >
      {/* Button */}
      <Button
        variant="contained"
        startIcon={open ? <CloseIcon /> : <MenuIcon />}
        sx={{
          background: "linear-gradient(90deg, #6a11cb, #8e2de2)",
          borderRadius: "8px",
          textTransform: "none",
          px: 3,
          py: 1,
          fontWeight: 400,
          fontSize: "14px",
          "&:hover": {
            background: "linear-gradient(90deg, #6a11cb, #8e2de2)",
          },
        }}
      >
        All Categories
      </Button>

      {/* Dropdown */}
      {open && (
        <Paper
          elevation={5}
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            minWidth: 220,
            borderRadius: "8px",
            p: 1,
            bgcolor: "#000", // ✅ Black background
          }}
        >
          {selectCategoryList?.map((category: any) => (
  <MenuItem
    key={category.ProductCategoryMasterID}
    onClick={() => {
      navigate("/shop", {
        state: {
          ProductCategoryMasterID:
            category.ProductCategoryMasterID,
        },
      });
    }}
    sx={{
      color: "#fff",
      borderRadius: "6px",
      "&:hover": {
        bgcolor: "#1a1a1a",
      },
    }}
  >
    {category.ProductCategoryName}
  </MenuItem>
))}
          {/* {selectCategoryList?.map((category: any) => (
            <Link
              key={category.ProductCategoryMasterID}
              to="/shop"
              style={{ textDecoration: "none" }}
            >
              <MenuItem
                value={category.ProductCategoryMasterID}
                
                sx={{
                  color: "#fff",
                  borderRadius: "6px",
                  "&:hover": {
                    bgcolor: "#1a1a1a",
                  },
                }}
              >
                {category.ProductCategoryName}
              </MenuItem>
            </Link>
          ))} */}
        </Paper>
      )}
    </Box>
  );
}
